import type { PublicFaqCategory } from "@/types/faq";
import type { Locale } from "./types";

/**
 * Gradi schema.org FAQPage čvor iz javnih FAQ kategorija.
 *
 * Vraća null kad nema nijednog upotrebljivog pitanja. Prazan `mainEntity`
 * Google tretira kao neispravan markup, pa je izostavljanje čvora ispravnije
 * od emitovanja praznog.
 */
export function buildFaqPageNode(
  categories: readonly PublicFaqCategory[],
  locale: Locale,
  pageId: string,
): Record<string, unknown> | null {
  const entities: Record<string, unknown>[] = [];

  for (const category of categories) {
    for (const item of category.items) {
      const question = locale === "en" ? item.questionEn : item.questionBs;
      const answer = locale === "en" ? item.answerEn : item.answerBs;
      if (!question?.trim() || !answer?.trim()) continue;
      entities.push({
        "@type": "Question",
        name: question.trim(),
        acceptedAnswer: { "@type": "Answer", text: answer.trim() },
      });
    }
  }

  if (entities.length === 0) return null;

  return {
    "@type": "FAQPage",
    "@id": `${pageId}#faq`,
    mainEntity: entities,
  };
}
